/**
 * 视图类型常量定义
 */
export const VIEW_TYPE = {
    LIST: "list", // 列表视图
    COMPACT: "compact", // 紧凑视图（Excel风格，高信息密度）
    CALENDAR: "calendar", // 日历视图
    TIMELINE: "timeline", // 时间轴视图
};

/**
 * 视图标签映射
 */
export const VIEW_TYPE_LABELS = {
    [VIEW_TYPE.LIST]: "列表视图",
    [VIEW_TYPE.COMPACT]: "紧凑视图",
    [VIEW_TYPE.CALENDAR]: "日历视图",
    [VIEW_TYPE.TIMELINE]: "时间轴视图",
};

/**
 * 默认活动视图
 */
export const DEFAULT_ACTIVE_VIEW = VIEW_TYPE.LIST;
